import { GradientTypography } from '../gradients/GradientTypography';
import { truncateIfTooLong } from 'src/util/truncate';

export type MatchHeaderProps = {
  team1Name: string;
  team2Name: string;
};

export const MatchHeader = ({ team1Name, team2Name }: MatchHeaderProps) => {
  return (
    <GradientTypography
      variant="h4"
      sx={{ textTransform: 'uppercase', textAlign: 'center' }}
      gradientColor="primary.vertical"
    >
      {'Match between '}
      <GradientTypography
        variant="h4"
        component="span"
        sx={{ textTransform: 'uppercase' }}
        gradientColor="success.vertical"
      >
        {truncateIfTooLong(team1Name)}
      </GradientTypography>
      {' and '}
      <GradientTypography
        variant="h4"
        component="span"
        sx={{ textTransform: 'uppercase' }}
        gradientColor="warning.vertical"
      >
        {truncateIfTooLong(team2Name)}
      </GradientTypography>
    </GradientTypography>
  );
};
